module.exports = __webpack_public_path__ + "static/media/landing_org_toronto.fe1b7cf7.png";